import {getEntidade} from "@/api/config/init";

const hash = require('object-hash');
import moment from 'moment'
import {cpf, cnpj} from 'cpf-cnpj-validator';

export function soNumeros(data) {
    return data.replace(/[^0-9]/gi, "");
}

export function geraHashObjeto(Objeto) {
    return hash(Objeto, {algorithm: 'md5', encoding: 'base64'});
}

export function geraHashObjetoIgual(Objeto, _hash) {
    return (hash(Objeto, {algorithm: 'md5', encoding: 'base64'}) === _hash);
}

export function getDate(formato = 'YYYY-MM-DD') {
    const today = moment();
    return today.format(formato);
}

export function dateIsValid(date, formato = 'YYYY-MM-DD') {
    return moment(date, formato).isValid()
}

export function getInicoAno() {
    return moment().format("YYYY-01-01");
}

export function getFimAno() {
    return moment().format("YYYY-12-31");
}

export function getInicoMes() {
    return moment().format("YYYY-MM-01");
}

export function getFimMes() {
    return moment().format("YYYY-MM-") + moment().daysInMonth();
}

export function getFimMesDate(date, formato = 'YYYY-MM-DD') {
    return moment(date).endOf('month').format(formato);
}

export function isDataIgualOuMaior(date, dataReferencia = '2026-11-01') {
    return moment(date, 'YYYY-MM-DD').isSameOrAfter(dataReferencia, 'day');
}

export function dataSqlHtml(date) {
    return moment(String(date)).format('DD/MM/YYYY')
}

export function getCompetencia() {
    return moment().format("YYYYMM");
}

export function validarEmail(email) {
    if (!email) return null;

    const valor = String(email).trim();

    // Só ASCII imprimível — barra ç, acentos e espaços
    if (!/^[\x21-\x7E]+$/.test(valor)) return false;
    if (valor.length > 254) return false;

    const regex = /^[a-zA-Z0-9](?:[a-zA-Z0-9._%+-]*[a-zA-Z0-9])?@(?:[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?\.)+[a-zA-Z]{2,}$/;
    if (!regex.test(valor)) return false;

    const [local, dominio] = valor.split('@');
    if (local.length > 64) return false;
    if (valor.includes('..')) return false;
    if (local.startsWith('.') || local.endsWith('.')) return false;

    const labels = dominio.split('.');
    return !labels.some(l => l.startsWith('-') || l.endsWith('-') || l.length === 0);
}

export function naCompetencia(inicio, fim) {
    const i = inicio.replace(/[^0-9]/gi, "");
    const f = fim.replace(/[^0-9]/gi, "");
    return i.toString().substring(0, 6) === f.toString().substring(0, 6);
}


export function tipoBoolean(dado) {
    return dado.toString() === 't';
}

export function getURLBlob(file) {
    return new Promise((resolve) => {
        let url = null
        let oReq = new XMLHttpRequest();
        oReq.open("GET", file, true);
        oReq.setRequestHeader("X-ACCESS-ENTIDADE", getEntidade());
        oReq.responseType = "blob";
        oReq.onload = function () {
            url = URL.createObjectURL(oReq.response);
            resolve(url)
        };
        oReq.send();
    })
}

export function isMobile() {
    return /iPhone|webOS|BlackBerry|Windows Phone|iPad|iPod|Android/i.test(navigator.userAgent)
}

export function isCnpj(val) {
    let cpfCnpj = val.trim();
    cpfCnpj = soNumeros(cpfCnpj);
    if (!cpfCnpj) {
        return false
    }
    return cpfCnpj.length === 14;
}

export function validaCpfCnpj(val) {
    let cpfCnpj = val.trim();
    cpfCnpj = cpfCnpj.replace(/\./g, '');
    cpfCnpj = cpfCnpj.replace('-', '');
    cpfCnpj = cpfCnpj.replace('/', '');
    if (cpfCnpj.length === 14) {
        return cnpj.isValid(cpfCnpj)
    }
    if (cpfCnpj.length === 11) {
        return cpf.isValid(cpfCnpj);
    }
    return false
}

export function validarTelefoneBR(tel) {
    if (!tel) return false;

    const n = tel.replace(/\D/g, '');

    // 10 ou 11 dígitos
    if (![10, 11].includes(n.length)) return false;

    const ddd = n.substring(0, 2);
    const numero = n.substring(2);

    // DDD não pode começar com 0
    if (ddd[0] === '0') return false;

    // Celular deve começar com 9 (regra ANATEL)
    if (n.length === 11 && numero[0] !== '9') return false;

    return true;
}

export function arredondamento(valor) {
    if (!valor) {
        valor = 0.00
    }
    const _valor = Number(valor);
    return _valor.toLocaleString('en-US', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
        useGrouping: false
    });
}

export function copy(value) {
    let testingCodeToCopy = document.createElement('input')
    testingCodeToCopy.setAttribute('type', 'hidden')
    testingCodeToCopy.setAttribute('type', 'text')
    testingCodeToCopy.value = value
    testingCodeToCopy.select();
    document.execCommand('copy');
    window.getSelection().removeAllRanges()
}

export function listMeses(ano, ano_inicial = null, mes_inicial = null) {
    const meses = [
        {
            "codigo": "01",
            "descricao": "Janeiro"
        },
        {
            "codigo": "02",
            "descricao": "Fevereiro"
        },
        {
            "codigo": "03",
            "descricao": "Março"
        },
        {
            "codigo": "04",
            "descricao": "Abril"
        },
        {
            "codigo": "05",
            "descricao": "Maio"
        },
        {
            "codigo": "06",
            "descricao": "Junho"
        },
        {
            "codigo": "07",
            "descricao": "Julho"
        },
        {
            "codigo": "08",
            "descricao": "Agosto"
        },
        {
            "codigo": "09",
            "descricao": "Setembro"
        },
        {
            "codigo": "10",
            "descricao": "Outubro"
        },
        {
            "codigo": "11",
            "descricao": "Novembro"
        },
        {
            "codigo": "12",
            "descricao": "Dezembro"
        }
    ];
    const ano_atual = new Date().getFullYear();
    const mes_atual = new Date().getMonth() + 1;
    const ano_parameter = parseInt(ano);

    if (ano_inicial !== null) {
        if (ano_parameter === parseInt(ano_inicial)) {
            return meses.filter((k) => k.codigo >= parseInt(mes_inicial));
        }
    }

    if (ano_parameter < ano_atual) {
        return meses;
    }

    if (ano_parameter > ano_atual) {
        return [];
    }

    return meses.filter((k) => k.codigo <= (mes_atual));

}
